import { ThankYouPage } from "./ThankYouPage";
export default ThankYouPage;
